import type IPaymentProvider from '../../../payment/IPaymentProvider';
import { AdditionalActionResponse } from '../../types';

const wrapper = (paymentProvider: IPaymentProvider | undefined) => ({
  handle: async ({ json } : AdditionalActionResponse) => {
    if (!paymentProvider) {
      throw new Error('A payment provider is required for the additional action response handler');
    }

    const payload = JSON.parse(json);

    const promise = paymentProvider.subscribe();

    paymentProvider.additionalAction(payload.action);

    const data: any = await promise;

    if (data.error) {
      throw data.error;
    }

    return {
      shouldResubmit: true,
      paymentProviderData: data,
    };
  },
});

export default wrapper;
